import { Injectable } from '@angular/core';
import { HttpServices } from './http-service.service';
import { GlobalServices } from './global.service';
import { Languages } from '../models/enums.model';
import { HttpHeaders } from '@angular/common/http';
import { AppConfig } from './app.config';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private http: HttpServices, private global: GlobalServices) { }

  public getShipyardReport(email: string, pageIndex: number, pageSize: number, dateFrom: string, dateTo: string, serviceId: string, statusId: string, requestNumber: string) {
    return this.http.get('Report/GetShipyardReport?email=' + email + '&pageIndex=' + pageIndex + '&pageSize=' + pageSize
      + '&language=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
      + '&from=' + dateFrom + '&to=' + dateTo + '&serviceId=' + serviceId + '&statusId=' + statusId + '&requestNumber=' + requestNumber);
  }


  public getEBookingReport(pageIndex: number, pageSize: number, sortBy: string, sortDir: string, userId: string, userName: string, requestNumber: string, dateFrom: string, dateTo: string, serviceId: string, statusId: string, directionId: string, transitDate: string, eta: string, vesselName: string, isPayed: Boolean) {

    return this.http.get('Report/GetEBookingReport?pageIndex=' + pageIndex + '&pageSize=' + pageSize
      + '&sortBy=' + sortBy + '&sortDir=' + sortDir
      + '&language=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
      + '&userId=' + userId + '&userName=' + userName + "&requestNumber=" + requestNumber + '&from=' + dateFrom + '&to=' + dateTo + '&serviceId=' + serviceId + '&statusId=' + statusId
      + '&directionId=' + directionId + '&transitDate=' + transitDate + '&eta=' + eta + '&vesselName=' + vesselName + '&isPayed=' + isPayed
    );
  }

  public getSmallUnitsReport(pageIndex: number, pageSize: number, sortBy: string, sortDir: string, userId: string, userName: string, requestNumber: string, dateFrom: string, dateTo: string, serviceId: string, statusId: string, directionId: string, transitDate: string, eta: string, vesselName: string, isPayed: Boolean) {

    return this.http.get('Report/GetSmallUnitsReport?pageIndex=' + pageIndex + '&pageSize=' + pageSize
      + '&sortBy=' + sortBy + '&sortDir=' + sortDir
      + '&language=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
      + '&userId=' + userId + '&userName=' + userName + "&requestNumber=" + requestNumber + '&from=' + dateFrom + '&to=' + dateTo + '&serviceId=' + serviceId + '&statusId=' + statusId
      + '&directionId=' + directionId + '&transitDate=' + transitDate + '&eta=' + eta + '&unitName=' + vesselName + '&isPayed=' + isPayed
    );
  }

  public getCrewChangeReport(pageIndex: number, pageSize: number, sortBy: string, sortDir: string, userId: string, userName: string, requestNumber: string, dateFrom: string, dateTo: string, serviceId: string, statusId: string, directionId: string, transitDate: string, isCompleted: boolean, vesselName: string) {

    return this.http.get('Report/getCrewChangeReport?pageIndex=' + pageIndex + '&pageSize=' + pageSize
      + '&sortBy=' + sortBy + '&sortDir=' + sortDir
      + '&language=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
      + '&userId=' + userId + '&userName=' + userName + "&requestNumber=" + requestNumber + '&from=' + dateFrom + '&to=' + dateTo + '&serviceId=' + serviceId + '&statusId=' + statusId
      + '&directionId=' + directionId + '&transitDate=' + transitDate + '&isCompleted=' + isCompleted + '&vesselName=' + vesselName
    );
  }
  public UpdateLongHaulRequestsToClosed(
    pageIndex: number,
    pageSize: number,
    sortBy: string,
    sortDir: string,
    userId: string,
    userName: string,
    requestNumber: string,
    submissionDateFrom: string,
    submissionDateTo: string,
    statusId: string,
    rebateFileNumber: string,
    imo: string,
    sailingDate: string,
    fromCountryId: string,
    toCountryId: string,
    fromPortId: string,
    toPortId: string,
    rebatePercentageFrom: string,
    rebatePercentageTo: string,
    shipTypeId: string,
    shipName: string,
    isPassed: Boolean,
    isrefunded: Boolean,
    isCancelled: Boolean,
    cancelationDateFrom: string,
    cancelationDateTo: string,
    directionId: string,
    formulatedDecisionDateFrom: string,
    formulatedDecisionDateTo: string) {
    var url = 'Report/UpdateLongHaulRequestsToClosed?'
      + "pageIndex=" + pageIndex
      + "&pageSize=" + pageSize
      + "&sortBy=" + sortBy
      + "&sortDir=" + sortDir
      + '&language=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
      + "&userId=" + userId
      + "&userName=" + userName
      + "&requestNumber=" + requestNumber
      + "&submissionDateFrom=" + submissionDateFrom
      + "&submissionDateTo=" + submissionDateTo
      + "&statusId=" + statusId
      + "&rebateFileNumber=" + rebateFileNumber
      + "&imo=" + imo
      + "&sailingDate=" + sailingDate
      + "&fromCountryId=" + fromCountryId
      + "&toCountryId=" + toCountryId
      + "&fromPortId=" + fromPortId
      + "&toPortId=" + toPortId
      + "&rebatePercentageFrom=" + rebatePercentageFrom
      + "&rebatePercentageTo=" + rebatePercentageTo
      + "&shipTypeId=" + shipTypeId
      + "&shipName=" + shipName
      + "&isPassed=" + isPassed
      + "&isrefunded=" + isrefunded
      + "&isCancelled=" + isCancelled
      + "&cancelationDateFrom=" + cancelationDateFrom
      + "&cancelationDateTo=" + cancelationDateTo
      + "&directionId=" + directionId
      + "&formulatedDecisionDateFrom=" + formulatedDecisionDateFrom
      + "&formulatedDecisionDateTo=" + formulatedDecisionDateTo;
    return this.http.get(url);
  }
  public getLongHaulReport(
    pageIndex: number,
    pageSize: number,
    sortBy: string,
    sortDir: string,
    userId: string,
    userName: string,
    requestNumber: string,
    submissionDateFrom: string,
    submissionDateTo: string,
    statusId: string,
    rebateFileNumber: string,
    imo: string,
    sailingDate: string,
    fromCountryId: string,
    toCountryId: string,
    fromPortId: string,
    toPortId: string,
    rebatePercentageFrom: string,
    rebatePercentageTo: string,
    shipTypeId: string,
    shipName: string,
    isPassed: Boolean,
    isrefunded: Boolean,
    isCancelled: Boolean,
    cancelationDateFrom: string,
    cancelationDateTo: string,
    directionId: string,
    formulatedDecisionDateFrom: string,
    formulatedDecisionDateTo: string) {
    var url = 'Report/GetLongHaulReport?'
      + "pageIndex=" + pageIndex
      + "&pageSize=" + pageSize
      + "&sortBy=" + sortBy
      + "&sortDir=" + sortDir
      + '&language=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
      + "&userId=" + userId
      + "&userName=" + userName
      + "&requestNumber=" + requestNumber
      + "&submissionDateFrom=" + submissionDateFrom
      + "&submissionDateTo=" + submissionDateTo
      + "&statusId=" + statusId
      + "&rebateFileNumber=" + rebateFileNumber
      + "&imo=" + imo
      + "&sailingDate=" + sailingDate
      + "&fromCountryId=" + fromCountryId
      + "&toCountryId=" + toCountryId
      + "&fromPortId=" + fromPortId
      + "&toPortId=" + toPortId
      + "&rebatePercentageFrom=" + rebatePercentageFrom
      + "&rebatePercentageTo=" + rebatePercentageTo
      + "&shipTypeId=" + shipTypeId
      + "&shipName=" + shipName
      + "&isPassed=" + isPassed
      + "&isrefunded=" + isrefunded
      + "&isCancelled=" + isCancelled
      + "&cancelationDateFrom=" + cancelationDateFrom
      + "&cancelationDateTo=" + cancelationDateTo
      + "&directionId=" + directionId
      + "&formulatedDecisionDateFrom=" + formulatedDecisionDateFrom
      + "&formulatedDecisionDateTo=" + formulatedDecisionDateTo;
    return this.http.get(url);
  }
  public getCircularsReport(
    pageIndex: number,
    pageSize: number,
    sortBy: string,
    sortDir: string,
    userId: string,
    userName: string,
    requestNumber: string,
    submissionDateFrom: string,
    submissionDateTo: string,
    statusId: string,
    rebateFileNumber: string,
    imo: string,
    sailingDateFrom: string,
    sailingDateTo: string,
    fromCountryId: string,
    toCountryId: string,
    fromPortId: string,
    toPortId: string,
    fromRegionId: string,
    toRegionId: string,
    circularId: string,
    rebatePercentageValue: string,
    shipTypeId: string,
    shipName: string,
    isPassed: Boolean,
    isrefunded: Boolean,
    isClosed: Boolean,
    directionId: string,
    decisionFeedbackDateFrom: string,
    decisionFeedbackDateTo: string) {
    var url = 'Report/GetCircularsReport?'
      + "pageIndex=" + pageIndex
      + "&pageSize=" + pageSize
      + "&sortBy=" + sortBy
      + "&sortDir=" + sortDir
      + '&language=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
      + "&userId=" + userId
      + "&userName=" + userName
      + "&requestNumber=" + requestNumber
      + "&submissionDateFrom=" + submissionDateFrom
      + "&submissionDateTo=" + submissionDateTo
      + "&statusId=" + statusId
      + "&rebateFileNumber=" + rebateFileNumber
      + "&imo=" + imo
      + "&sailingDateFrom=" + sailingDateFrom
      + "&sailingDateTo=" + sailingDateTo
      + "&fromCountryId=" + fromCountryId
      + "&toCountryId=" + toCountryId
      + "&fromPortId=" + fromPortId
      + "&toPortId=" + toPortId
      + "&fromRegionId=" + fromRegionId
      + "&toRegionId=" + toRegionId
      + "&circularId=" + circularId
      + "&rebatePercentageValue=" + rebatePercentageValue
      + "&shipTypeId=" + shipTypeId
      + "&shipName=" + shipName
      + "&isPassed=" + isPassed
      + "&isrefunded=" + isrefunded
      + "&isClosed=" + isClosed
      + "&directionId=" + directionId
      + "&decisionFeedbackDateFrom=" + decisionFeedbackDateFrom
      + "&decisionFeedbackDateTo=" + decisionFeedbackDateTo;
    return this.http.get(url);
  }

  public getReleaseReport(
    pageIndex: number,
    pageSize: number,
    sortBy: string,
    sortDir: string,
    agentName: string,
    longHaulRequestNumber: string,
    requestNumber: string,
    submissionDateFrom: string,
    submissionDateTo: string,
    statusId: string,
    rebateFileNumber: string,
    imo: string,
    vesselName: string,
    releaseFormCreatorEmail: string,
    serviceTypeId: string,
    refundDateFrom: string,
    refundDateTo: string
  ) {
    const url = 'Report/GetReleaseReport?'
      + "pageIndex=" + pageIndex
      + "&pageSize=" + pageSize
      + "&sortBy=" + sortBy
      + "&sortDir=" + sortDir
      + "&language=" + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
      + "&agentName=" + encodeURIComponent(agentName)
      + "&longHaulRequestNumber=" + longHaulRequestNumber
      + "&requestNumber=" + requestNumber
      + "&submissionDateFrom=" + submissionDateFrom
      + "&submissionDateTo=" + submissionDateTo
      + "&statusId=" + statusId
      + "&rebateFileNumber=" + rebateFileNumber
      + "&imo=" + imo
      + "&vesselName=" + encodeURIComponent(vesselName)
      + "&releaseFormCreatorEmail=" + releaseFormCreatorEmail
      + "&serviceTypeId=" + serviceTypeId
      + "&refundDateFrom=" + refundDateFrom
      + "&refundDateTo=" + refundDateTo;
  
    return this.http.get(url);
  }
  

  public getShipyardReportFilterLookups() {
    return this.http.get('Lookups/GetShipyardReportLookups');
  }

  public getEbookingReportLookups() {
    return this.http.get('Lookups/GetEbookingReportLookups');
  }

  public getSmallUnitsReportLookups() {
    return this.http.get('Lookups/GetSmallUnitsReportLookups');
  }
  public ExportShipyardReportExcel(currentUser: string, shipyardObject: string, language: string,
    from: string, to: string, serviceId: string, statusId: string, requestNumber: string) {
    const httpOptions = {
      responseType: 'blob' as 'json'
    };
    return this.http.http.post(AppConfig.settings.apiServer.apiUrl +
      "Report/ExportShipyardReportExcel?email=" + currentUser + "&language=" + language + "&from=" + from +
      "&to=" + to + "&serviceId=" + serviceId + "&statusId=" + statusId + "&requestNumber=" + requestNumber, { Data: shipyardObject }, httpOptions)
      .subscribe(result => {
        this.downLoadFile(result, 'application/vnd.ms-excel');
      }, () => { }, () => {
      });
  }
  downLoadFile(data: any, type: string) {
    const blob = new Blob([data], { type });
    saveAs(blob, 'ExcelReport.xlsx');
  }


}
